import { render, staticRenderFns } from "./AgendaRegra.vue?vue&type=template&id=39908bf4&"
import script from "./AgendaRegra.vue?vue&type=script&lang=js&"
export * from "./AgendaRegra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports